import api from "../../lib/api";

export const EMOJIS = "😀 😃 😄 😁 😆 😅 😂 🤣 😊 😍 🥰 😘 😎 🤩 🥳 😇 🙂 😉 🤗 🤔 😴 🙌 👏 👍 👋 🙏 💪 👀 ❤️ 🧡 💛 💚 💙 💜 🖤 🤍 ✨ ⭐ 🌟 🔥 💥 🎉 🎊 🎈 🎁 🎂 🍰 🧁 🍩 🍪 🍕 🍔 🌮 🥗 🍣 🍿 ☕ 🍵 🍺 🍷 🥂 🍾 🍹 🧃 🍎 🍓 🍉 🍋 🌸 🌻 🌷 🍁 🍂 🎃 👻 🦃 🎄 ❄️ ☀️ 🌈 ☔ 🌙 📅 🗓️ ⏰ 📣 📢 📌 📍 🔔 💡 📚 💻 📱 📸 🎵 🎶 🎤 🎨 🧘 🏃 🚴 ⚽ 🏀 🎾 🏆 🥇 💼 🏢 🤝 💬 ✅ ☑️ ➡️ ⬇️ 🆕 🆓 💯 🇺🇸".split(" ");

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/newsletters/images", fd);
  return data;
}

export function naturalSize(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ w: img.naturalWidth, h: img.naturalHeight });
    img.onerror = () => resolve(null);
    img.src = url;
  });
}

export function pickFile() {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = () => resolve(input.files?.[0] || null);
    input.click();
  });
}
